/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createArg } from '../../factoriesAny.js';
export var argDependencies = {
  typedDependencies: typedDependencies,
  createArg: createArg
};